/**
 * WebAuthn admin API layer. Admin endpoints require a SENSE_ADMIN-tier JWT,
 * sent as `Authorization: SENSE_ADMIN <jwt>` (distinct from the analyst
 * `ANALYST <jwt>` scheme). The stored token is reused; the backend enforces
 * the tier.
 */
import apiClient from "../../../utils/axiosClient";
import { ENDPOINTS, WEBAUTHN_MOCK } from "../config";

function unwrap(res) {
  const d = res && res.data;
  if (d && typeof d === "object" && "response_data" in d) return d.response_data;
  return d;
}

function adminHeaders() {
  const token = sessionStorage.getItem("token");
  return token ? { Authorization: `ANALYST ${token}` } : {};
}

function mock() {
  // eslint-disable-next-line global-require
  return require("./mock").mockApi;
}

export const adminWebauthnApi = {
  listRequests() {
    if (WEBAUTHN_MOCK) return mock().adminRequests().then((r) => r.results || []);
    return apiClient
      .get(ENDPOINTS.adminRequests, { headers: adminHeaders() })
      .then(unwrap)
      .then((rd) => (rd && rd.requests) || []);
  },
  approveRequest(id) {
    if (WEBAUTHN_MOCK) return mock().adminApprove(id);
    return apiClient.post(ENDPOINTS.adminApprove(id), {}, { headers: adminHeaders() }).then(unwrap);
  },
  rejectRequest(id, reason) {
    if (WEBAUTHN_MOCK) return mock().adminReject(id, reason);
    return apiClient
      .post(ENDPOINTS.adminReject(id), { reason }, { headers: adminHeaders() })
      .then(unwrap);
  },

  analystCredentials(analystId) {
    if (WEBAUTHN_MOCK) return mock().listCredentials();
    return apiClient
      .get(ENDPOINTS.adminAnalystCredentials(analystId), { headers: adminHeaders() })
      .then(unwrap)
      .then((rd) => (rd && rd.credentials) || []);
  },
  disableCredential(id) {
    if (WEBAUTHN_MOCK) return mock().adminDisableCredential(id);
    return apiClient
      .post(ENDPOINTS.adminDisableCredential(id), {}, { headers: adminHeaders() })
      .then(unwrap);
  },
  deleteCredential(id) {
    if (WEBAUTHN_MOCK) return mock().adminDeleteCredential(id);
    return apiClient
      .delete(ENDPOINTS.adminDeleteCredential(id), { headers: adminHeaders() })
      .then(unwrap);
  },
  setExpiry(id, durationDays) {
    if (WEBAUTHN_MOCK) return Promise.resolve({});
    return apiClient
      .post(ENDPOINTS.adminSetExpiry(id), { duration_days: durationDays }, { headers: adminHeaders() })
      .then(unwrap);
  },
  analystLoginHistory(analystId, limit = 50) {
    if (WEBAUTHN_MOCK) return Promise.resolve([]);
    return apiClient
      .get(ENDPOINTS.adminAnalystLoginHistory(analystId), {
        params: { limit },
        headers: adminHeaders(),
      })
      .then(unwrap)
      .then((rd) => (rd && rd.login_history) || []);
  },
};
